import { render, staticRenderFns } from "./outside-click-detector.vue?vue&type=template&id=60663816&"
import script from "./outside-click-detector.vue?vue&type=script&lang=js&"
export * from "./outside-click-detector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports